function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_138",
  "data-name": "Path 138",
  d: "M23.1,13a10.1,10.1,0,1,0,10.1,10.1A10.1,10.1,0,0,0,23.1,13Z",
  transform: "translate(37.514 31.549)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_139",
  "data-name": "Path 139",
  d: "M63.617,17.84c31.607,0,51.777,12.714,51.777,21.469,0,4.44-4.809,9.5-12.866,13.523-10.1,5.051-24.282,7.946-38.911,7.946-31.607,0-51.777-12.714-51.777-21.469,0-4.44,4.809-9.5,12.866-13.523,10.1-5.051,24.282-7.946,38.911-7.946m0-8.84C30.141,9,3,22.568,3,39.309S30.141,69.617,63.617,69.617s60.617-13.568,60.617-30.309S97.093,9,63.617,9Z",
  transform: "translate(-3 15.343)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_140",
  "data-name": "Path 140",
  d: "M25.331,13.021c9.78,0,27.268,12.3,40.422,35.077,7.314,12.669,11.9,26.4,12.573,37.669.54,8.992-1.435,15.685-5.279,17.907a7.9,7.9,0,0,1-4.061.975c-9.78,0-27.268-12.3-40.422-35.077C21.25,56.9,16.663,43.173,15.991,31.9,15.45,22.912,17.426,16.219,21.27,14a7.9,7.9,0,0,1,4.061-.975m0-8.84A16.752,16.752,0,0,0,16.85,6.338C2.352,14.708,4.171,45,20.911,73.987c13.816,23.929,33.481,39.5,48.08,39.5a16.752,16.752,0,0,0,8.481-2.157c14.5-8.37,12.679-38.659-4.061-67.649C59.59,19.75,39.925,4.181,25.331,4.181Z",
  transform: "translate(13.459 -4.181)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_141",
  "data-name": "Path 141",
  d: "M68.986,13.021A7.916,7.916,0,0,1,73.047,14c3.844,2.218,5.819,8.916,5.279,17.907-.677,11.27-5.259,25-12.573,37.669C52.6,92.359,35.111,104.649,25.331,104.649a7.915,7.915,0,0,1-4.061-.975c-3.844-2.218-5.819-8.916-5.279-17.907.677-11.27,5.259-25,12.573-37.669C41.723,25.311,59.211,13.021,68.986,13.021m0-8.84c-14.6,0-34.259,15.569-48.08,39.5-16.735,29-18.554,59.279-4.056,67.649a16.725,16.725,0,0,0,8.481,2.157c14.6,0,34.259-15.569,48.08-39.5,16.735-29,18.554-59.279,4.056-67.649a16.675,16.675,0,0,0-8.481-2.157Z",
  transform: "translate(13.459 -4.181)"
});

function SvgReact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons8-react_1_",
    "data-name": "icons8-react (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 121.234,
    height: 109.303,
    viewBox: "0 0 121.234 109.303",
    transform: "translate(0 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/React.4509b136.svg";
export { ForwardRef as ReactComponent };